import { Layout } from "antd";
import { motion } from "framer-motion";
import styled from "styled-components";

import { Paragraph, Title } from "@/components/Typography";
import breakpoints from "@/constants/breakpoints";

export const Container = styled(Layout)`
    min-height: 100vh;
`;

export const LeftContainer = styled.section`
    height: 100vh;
    margin-right: 0;
    overflow-y: scroll;

    @media ${breakpoints.xl} {
        margin-right: 700px;
    }
`;

export const LeftContent = styled.div`
    display: grid;
    grid-template-rows: auto max-content auto max-content;
    width: auto;
    max-width: 448px;
    min-height: 100vh;
    padding: 44px 20px;
    margin: 0 auto;

    @media ${breakpoints.xl} {
        width: 448px;
        padding: 44px 0;
    }
`;

export const RightContainer = styled.section`
    position: fixed;
    top: 0;
    right: 0;
    display: none;
    flex-direction: column;
    max-width: 700px;
    min-height: 100vh;
    padding: 60px 90px;
    white-space: pre-line;
    background: conic-gradient(from 108.99deg at 26.26% 19.04%, rgb(120 248 205) 0deg, #293138 360deg, rgb(30 200 142 / 30%) 360deg);
    background-position: center;
    background-size: cover;

    @media screen and (height >=700px) {
        padding: 60px 120px;
    }

    @media ${breakpoints.xl} {
        display: flex;
    }
`;

export const RightContent = styled.div`
    z-index: 1;
    display: flex;
    flex-direction: column;
    padding-right: 20%;
    margin-top: 180px;

    @media screen and (height >=700px) {
        margin-top: 260px;
    }
`;

export const RightLogo = styled.img`
    position: absolute;
    top: 30px;
    right: 40px;
`;

export const RightIcon = styled(motion.img)`
    position: absolute;
    top: 40px;
    right: 150px;
    width: 300px;

    @media screen and (height >=700px) {
        width: 400px;
    }
`;

export const RightFooter = styled.footer`
    display: flex;
    justify-content: center;
    margin-top: auto;
`;

export const RightFooterContent = styled.div`
    display: grid;
    grid-template-columns: auto auto auto;
    gap: 15px 25px;
    width: 100%;
`;

export const CompanyFigure = styled.figure`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0%;
`;

export const TitleStyled = styled(Title)`
    margin-bottom: 24px;
    color: ${props => props.theme.layouts.authenticationLayout.color};
`;

export const ParagraphStyled = styled(Paragraph)`
    color: ${props => props.theme.layouts.authenticationLayout.color};
`;
